import { useTranslation } from "react-i18next"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@f2e/ui/components/base"
import type { ClientUserTag } from "@/hooks/api"

export interface ClientUserTagDeleteDialogProps {
  tag: ClientUserTag | null
  loading: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const ClientUserTagDeleteDialog = ({
  tag,
  loading,
  onOpenChange,
  onConfirm,
}: ClientUserTagDeleteDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog open={!!tag} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("crm.userManagement.tags.deleteTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                {t("crm.userManagement.tags.deleteDescription", {
                  name: tag?.name || "",
                })}
              </p>
              <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-100">
                {t("crm.userManagement.tags.deleteImpact", {
                  count: tag?.client_user_count ?? 0,
                })}
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            {t("crm.userManagement.detail.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700"
          >
            {loading
              ? t("crm.userManagement.tags.deleting")
              : t("crm.userManagement.tags.confirmDelete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
